import React, { Component as C } from "react"
import PropTypes from "prop-types"
import punycode from "punycode"
import _ from "lodash"

import StatelessTextInput from "../stateless-text-input/index.jsx"

export default class extends C {
  constructor(props) {
    super(props)
    this.state = { value: props.value || "" }
  }

  static propTypes = {
    mask: PropTypes.string,
    onChange: PropTypes.func,
    onCopy: PropTypes.func,
  }

  static defaultProps = {
    mask: "•",
  }

  get value() {
    return this.state.value
  }

  get mask() {
    let { mask } = this.props
    return this.encode([this.decode(mask)[0]])
  }

  get maskedValue() {
    return _.repeat(this.mask, this.decode().length)
  }

  encode(str = this.value) {
    return punycode.ucs2.encode(str)
  }

  decode(str = this.value) {
    return punycode.ucs2.decode(str)
  }

  handleChange(e) {
    let oldChars = this.decode()
    let newChars = this.decode(e.target.value)
    let maskCode = this.decode(this.mask)[0]
    let newValue = this.encode(newChars.map((c, i) => (c === maskCode ? oldChars[i] || c : c)))

    this.setState({ value: newValue }, () => {
      this.props.onChange && this.props.onChange(e, this.value)
    })
  }

  handleCopy(e) {
    e.preventDefault()
    e.clipboardData.setData("Text", this.state.value)
    this.props.onCopy && this.props.onCopy(e)
  }

  render() {
    return (
      <StatelessTextInput
        {...this.props}
        value={this.maskedValue}
        onChange={this.handleChange.bind(this)}
        onCopy={this.handleCopy.bind(this)}
      />
    )
  }
}
